export default __webpack_public_path__ + "static/media/R57SR57.f7952543.png";